import { Heading, Text, Box } from '@medely/ui-kit';
import React from 'react';
import { ApplicationReceivedItem } from './components/ApplicationReceivedItem';

export const ApplicationReceived = () => {
  return (
    <Box p={4}>
      <Box py={2}>
        <Heading size="l" testId="thank-you-title">
          Application Received!
        </Heading>
      </Box>
      <Text size="m" testId="thank-you-subtitle">
        A Medely Clinical Specialist will review your application and reach out shortly with your
        next steps.
      </Text>
      <Box py={2}>
        <Heading size="m">Why Medely</Heading>
      </Box>

      <ApplicationReceivedItem iconName="phone" text="Independently book shifts from your phone" />
      <ApplicationReceivedItem
        iconName="mobile"
        text="Work flexibly—there’s no minimum commitment"
      />
      <ApplicationReceivedItem
        iconName="location-dot"
        text="Book single PRN shifts and assignments in your area"
      />
      <ApplicationReceivedItem
        iconName="plane"
        text="Find travel assignments throughout the United States"
      />
      <ApplicationReceivedItem iconName="award" text="Medely is Joint Commission Certified" />
    </Box>
  );
};
